import * as React from 'react';

import {
	ButtonsWrapper,
	Button,
} from './styles';
import Select from '../Select';
import Utils from '../../../../utils';

interface TextPanelActions {
	onFontFamilyChange: () => void;
	onFontSizeChange: () => void;
	onColorChange: () => void;
	onLineHeightChange: () => void;
	onLetterSpacingChange: () => void;
	onFontWeightClick: () => void;
	onFontStyleClick: () => void;
	onTextDecorationClick: () => void;
	onTextAlignLeftClick: () => void;
	onTextAlignCenterClick: () => void;
	onTextAlignRightClick: () => void;
	onTextAlignJustifyClick: () => void;
}

interface TextPanelProps {
	fontFamily: string;
	fontSize: string;
	color: string;
	lineHeight: string;
	letterSpacing: string;
	isBoldActive: boolean;
	isItalicActive: boolean;
	isUnderlineActive: boolean;
	isTextAlignLeft: boolean;
	isTextAlignCenter: boolean;
	isTextAlignRight: boolean;
	isTextAlignJustify: boolean;
	fontFamilyOptions: {
		value: string;
		label: React.ReactNode;
	}[];
	fontSizeOptions: {
		value: string;
		label: string;
	}[];
	colorOptions: {
		value: string;
		label: React.ReactNode;
	}[];
	lineHeightOptions: {
		value: string;
		label: string;
	}[];
	letterSpacingOptions: {
		value: string;
		label: string;
	}[];
	actions: TextPanelActions;
}

const TextPanel = ({
	fontFamily,
	fontSize,
	color,
	lineHeight,
	letterSpacing,
	isBoldActive,
	isItalicActive,
	isUnderlineActive,
	isTextAlignLeft,
	isTextAlignCenter,
	isTextAlignRight,
	isTextAlignJustify,
	fontFamilyOptions,
	fontSizeOptions,
	colorOptions,
	lineHeightOptions,
	letterSpacingOptions,
	actions: {
		onFontFamilyChange,
		onFontSizeChange,
		onColorChange,
		onLineHeightChange,
		onLetterSpacingChange,
		onFontWeightClick,
		onFontStyleClick,
		onTextDecorationClick,
		onTextAlignLeftClick,
		onTextAlignCenterClick,
		onTextAlignRightClick,
		onTextAlignJustifyClick,
	},
}: TextPanelProps) => (
	<>
		<Select
			label="messages.font"
			value={fontFamily}
			isFontSelect={true}
			options={fontFamilyOptions}
			onChange={onFontFamilyChange}
		/>
		<ButtonsWrapper>
			<Button
				isActive={isBoldActive}
				isBold={true}
				onClick={onFontWeightClick}
			>
				B
			</Button>
			<Button
				isActive={isItalicActive}
				isItalic={true}
				onClick={onFontStyleClick}
			>
				I
			</Button>
			<Button
				isActive={isUnderlineActive}
				isUnderline={true}
				onClick={onTextDecorationClick}
			>
				U
			</Button>
		</ButtonsWrapper>
		<Select
			label="messages.size"
			value={fontSize}
			options={fontSizeOptions}
			onChange={onFontSizeChange}
		/>
		<Select
			label="messages.color"
			value={color}
			isColorSelect={true}
			options={colorOptions}
			onChange={onColorChange}
		/>
		<ButtonsWrapper isTextAlign={true}>
			<Button
				isActive={isTextAlignLeft}
				onClick={onTextAlignLeftClick}
			>
				{Utils.getSvgIcon('iconset_uprez_text-align-left')}
			</Button>
			<Button
				isActive={isTextAlignCenter}
				onClick={onTextAlignCenterClick}
			>
				{Utils.getSvgIcon('iconset_uprez_text-align-center')}
			</Button>
			<Button
				isActive={isTextAlignRight}
				onClick={onTextAlignRightClick}
			>
				{Utils.getSvgIcon('iconset_uprez_text-align-right')}
			</Button>
			<Button
				isActive={isTextAlignJustify}
				onClick={onTextAlignJustifyClick}
			>
				{Utils.getSvgIcon('iconset_uprez_text-align-justify')}
			</Button>
		</ButtonsWrapper>
		<Select
			label="messages.line_height"
			value={lineHeight}
			isLineHeightSelect={true}
			options={lineHeightOptions}
			onChange={onLineHeightChange}
		/>
		<Select
			label="messages.spacing"
			value={letterSpacing}
			options={letterSpacingOptions}
			onChange={onLetterSpacingChange}
		/>
	</>
);

export default TextPanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/TextPanel/index.tsx